import styles from './ProductSearchCard.module.css'
import { BasicStyledComponent, DSProductSearchCard } from 'shared-definitions/types'
import clsx from 'clsx'
import AppImage from './AppImage'
import RWButton from '../buttons/RWButton'
import { AppEventsContext } from '../contexts/AppEventsContext'
import Linked from '../service/Linked'
import ArrowRight from 'shared-svg/ArrowRight.svg'

const ProductSearchCard: React.FC<BasicStyledComponent & DSProductSearchCard> = ({
  title,
  checkPriceText,
  className,
  image,
  reviewLink,
  shopLink,
  badge,
}) => {
  const { appEvent } = AppEventsContext.useContainer()
  const imageContent = (
    <>
      <RWButton size="small" variant="primary" type="button" className={styles.readReviewButton}>
        {'Read Review'}
        <ArrowRight className={styles.arrowRight} />
      </RWButton>
      <AppImage
        className={styles.image}
        layout="fill"
        image={image}
        sizes={[{ bp: 'md', val: 300 }, 80]}
      />
      {badge ? (
        <AppImage
          image={badge}
          imageClassName={styles.badgeImage}
          className={styles.badge}
          sizes={[{ bp: 'md', val: 48 }, 25]}
          layout="raw"
        />
      ) : null}
    </>
  )

  return (
    <div className={clsx(styles.container, className)}>
      {reviewLink ? (
        <Linked {...reviewLink} className={styles.imageContainer}>
          {imageContent}
        </Linked>
      ) : (
        <div className={styles.imageContainer}>{imageContent}</div>
      )}
      <div className={styles.content}>
        {reviewLink ? (
          <Linked {...reviewLink} className={styles.title}>
            {title}
          </Linked>
        ) : (
          <div className={styles.title}>{title}</div>
        )}
        {shopLink && (
          <RWButton
            variant="secondary"
            size="small"
            pLink={shopLink}
            onClick={() => {
              appEvent({
                event: 'widget-interaction',
                widgetType: 'Clearbuy Best List Topper',
                label: 'Check price',
                url: shopLink?.href ?? '',
              })
            }}
          >
            {checkPriceText}
          </RWButton>
        )}
      </div>
    </div>
  )
}

export default ProductSearchCard
